import React from 'react';

import './Login.css';

import Form from './Form';

function Login() {
	return (
		<div className='div-container'>
			<div className='item1'>
				<div className='img' />
			</div>

			{/* <div className='item2'> */}
			<Form />
			{/* </div> */}
		</div>
	);
}

export default Login;
